import { Form } from './form';

export class ChangeEmailForm extends Form {

    constructor(form, container, view) {
        super(form);
        this.container = container;
        this.view = view;
        this.addFormBehavior();
    }

    addFormBehavior() {
        this.onSubmit();
    }

    onSubmit() {
        let self = this;

        this.submitButton.addEventListener('click', function(event) {
            let disabled = event.srcElement.classList.contains('disabled');
            if (disabled) {
                return;
            }

            let newEmail = self.form.querySelector('#newEmailAddress').value;
            let confirmEmail = self.form.querySelector('#confirmEmailAddress').value;
            let result = newEmail.localeCompare(confirmEmail,undefined,{sensitivity: 'accent'}) === 0

            if (!result){
                let compareError = document.querySelector('#confirmEmailAddress').parentElement;
                compareError.classList.add('invalid');
                return;
            }

            // submit logic
            self.form.submit();
        });
    }
}
